// extracted by mini-css-extract-plugin
var _1 = "ProfileCreatedWidget-modulecontent__GRQSW";
var _2 = "ProfileCreatedWidget-moduleskeleton__SPHqi WidgetContentSkeleton-moduleWidgetContentSkeleton__eblVC";
export { _1 as "content", _2 as "skeleton" }
